<template>
  <div class="pub-empty-nav">
    <p><img src="~@/assets/images/empty.jpg" /></p>
    <span><slot>暂无数据</slot></span>
  </div>
</template>
<script>
export default {
  name: "PubEmpty",
  props: [],
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/base.less";
.pub-empty-nav {
  padding: 30px 0;
  span,
  p {
    display: block;
    clear: both;
    margin: 0;
    text-align: center;
  }
  p {
    img {
      margin: 0 auto;
      width: 250px;
    }
  }
  span {
    color: #b5b5b5;
    font-size: 14px;
    padding-top: 20px;
    line-height: 22px;
  }
}
</style>
